export class RequiredPatternPasswordError extends Error {
    constructor() {
        super("Password doesn't meet requirements");
        this.name = 'RequiredPatternPasswordError';
    }
}
